import { Link } from "react-router-dom";
import CONSTANTS from "../../Constants";
import { pushEventToGTM } from "../../helpers/trackerManager";


const AppointmentSummaryBlock = ({ date, hour }) => {
    const disabled = (hour !== undefined) ? '' : 'disabled'
    return (

        <div className='appointmentDetails'>
            <div className='row'>
                <div className='date-col'>
                    <div tabIndex="0" className='row-name'>{CONSTANTS.LABELS.header_modification_date}</div>
                    <div tabIndex="0" className='row-date-value'>  {date || '-'}  </div>
                </div>
                <div className='slot-col'>
                    <div tabIndex="0" className='row-name'>{CONSTANTS.LABELS.header_modification_time}</div>
                    <div tabIndex="0" className='row-slot-value'> {hour || '-'} </div>
                </div>
            </div>
            <Link to={CONSTANTS.SITE_ROUTS.YOURAPPOINTMENTPAGE}
                className={`edit-link ${disabled}`}
                onClick={() => pushEventToGTM({
                    pageName: 'all',
                    eventAction: 'Redirection::Internal::Appointment',
                    eventLabel: CONSTANTS.LABELS.common_v2_modify,
                    eventCategory: 'Header'
                })
                }
                onKeyDown = {(e)=> e.key === 'Enter' && pushEventToGTM({
                    pageName: 'all',
                    eventAction: 'Redirection::Internal::Appointment',
                    eventLabel: CONSTANTS.LABELS.common_v2_modify,
                    eventCategory: 'Header'
                })}
            >
                {CONSTANTS.LABELS.common_v2_modify}
            </Link>
        </div>

    )
}
export default AppointmentSummaryBlock;